import { SCORING_RULE, ScoringRuleType } from '../../../../constants/scoringRule';

export const SCORING_RULE_DESCRIPTION: Record<ScoringRuleType, string | null> = {
  [SCORING_RULE.FAT_LOSS_MUSCLE_GAIN_FOOD_TRACKING]:
    'Adjusted fat loss = Fat Loss % * Muscle gain multiplier',
  [SCORING_RULE.FAT_LOSS_MUSCLE_GAIN]:
    'Adjusted Score (%) = Actual Fat Loss % x Muscle +/- Factor',
  [SCORING_RULE.FAT_LOSS]: null,
};
